import { Box } from '@mui/material'

export default function BottomBar(props: any) {

  return (
    <Box
      component={"div"}
      sx={{
        display: "flex",
        position: "fixed",
        bottom: 0,
        zIndex: "1200"
      }}
      width={"100%"}
      height={props.height}
      style={{backgroundColor: "#060B0C"}}
    >
      {props.children}
    </Box>
  )
}